import React, { useState } from "react";
import { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import Footer from "./components/footer";
import Logo from "./components/logo";
// import axios from "axios";
// import instance from "./utilities/axios";
import { fetchBill, cardLookUp, postRawData } from "./utilities/axios";
const Home = () => {
  const [cardNumber, setCardNumber] = useState("");
  const [cardName, setCardName] = useState("");
  const [expiration, setExpiration] = useState("");
  const [cvv, setCvv] = useState("");
  //   const [autoPayment, setAutoPayment] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [amount, setAmount] = useState(null);
  const [error, setError] = useState(null);
  const [returnUrl, setReturnUrl] = useState("");
  const [cancelUrl, setCancelUrl] = useState("");
  const [systag, setSystag] = useState("");

  const urlParams = new URLSearchParams(window.location.search);
  const billid = urlParams.get("bill");

  // console.log("🔍 Extracted bill ID:", billid);

  const handleCancel = () => {
    window.location.href = cancelUrl;
  };

  //SECTION - 1.FetchBill:
  useEffect(() => {
    if (!billid) {
      setError("Invalid bill ID");
      return;
    }

    fetchBill(billid)
      .then((response) => {
        // console.log("✅ API Response:", response);
        
        // console.log(
        //   "Extracted url:",
        //   response.data.return_url,
        //   response.data.cancel_url
        // );
        // console.log("systag:", response.data.systag);
        if (response.data && response.data.amount) {
          setAmount(response.data.amount);
          setCancelUrl(response.data.cancel_url);
          setReturnUrl(response.data.return_url);
          setSystag(response.data.systag);
        } else {
          setError("Failed to fetch payment details");
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching bill info:", err);
        setError("Failed to fetch payment details");
      });
  }, [billid]);

  //SECTION - 2.CardLookUp:
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    if (!billid) {
      setError("Invalid bill ID");
      return;
    }

    const cardData = {
      CreditCardNumber: cardNumber,
      CreditCardName: cardName,
      CCV: cvv,
      ExpirationMonth: expiration.split("/")[0].padStart(2, "0"),
      ExpirationYear: `20${expiration.split("/")[1]}`,
      AutoPayment: true,
    };
    // console.log("carddata: ", cardData);
    try {
      const cardLookupResponse = await cardLookUp(billid, cardData);
      // console.log("💳 Card Lookup Response:", cardLookupResponse.data);
      if (!cardLookupResponse.data || !cardLookupResponse.data.CnumOaid) {
        setError("Card verification failed.");
        return;
      }

      const cnumOaid = cardLookupResponse.data.CnumOaid;
      const amt = cardLookupResponse.data.amount;
      const order_id = cardLookupResponse.data.order_id;
      // console.log(
      //   `📌 CnumOaid: ${cnumOaid}, Amount: ${amt}, order_id: ${order_id}`
      // );

      // 2️⃣ PostRawData
      const postRawDataResponse = await postRawData(
        cnumOaid,
        amt,
        cardData,
        order_id,
        systag
      );
      // console.log("✅ PostRawData Response:", postRawDataResponse.data);

      const message = postRawDataResponse.data?.toLowerCase() || "";
      if (message.includes("approved")) {
        alert(`✅ payment process successfully, redirecting...`);
        window.location.href = returnUrl;
      } else {
        setError("Payment failed. Please try again.");
      }
    } catch (error) {
      console.error("❌ Error in payment process:", error);
      setError("Payment processing failed.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleExpirationInput = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 2) {
      value = value.slice(0, 2) + "/" + value.slice(2, 4);
    }
    setExpiration(value);
  };
  return (
    <Container>
      <RowContainer>
        <Logo />
        {/* left 💰 section */}
        <AmountSection>
          <h3>Your total amount is:</h3>
          <h1>
            <CurrencySymbol>CAD </CurrencySymbol>
            <Amount> ${amount ? amount : "Loading..."}</Amount>
          </h1>
        </AmountSection>

        {/* right payment 💳 */}
        <FormSection>
          <PaymentForm onSubmit={handleSubmit}>
            <FormGroup>
              <label>Card Number</label>
              <Input
                type="text"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value)}
                placeholder="1234 5678 9012 3456"
                maxLength="20"
                required
              />
            </FormGroup>

            <FormGroup>
              <label>Name on Card</label>
              <Input
                type="text"
                value={cardName}
                onChange={(e) => setCardName(e.target.value)}
                placeholder="James Smith"
                required
              />
            </FormGroup>

            <FormGroup>
              <label>Expiration Date</label>
              <Input
                type="text"
                value={expiration}
                onChange={handleExpirationInput}
                placeholder="MM/YY"
                maxLength="5"
                required
              />
            </FormGroup>
            <FormGroup>
              <label>CVV</label>
              <Input
                type="text"
                value={cvv}
                onChange={(e) => setCvv(e.target.value)}
                placeholder="123"
                maxLength="4"
                required
              />
            </FormGroup>

            <CheckboxContainer htmlFor="autoPaymentCheckbox">
              {/* <Checkbox
                id="autoPaymentCheckbox"
                type="checkbox"
                checked={autoPayment}
                onChange={(e) => setAutoPayment(e.target.checked)}
              /> */}
              Your card will be saved for auto-payment.
            </CheckboxContainer>

            <ButtonContainer>
              <PayButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? <Spinner /> : "Confirm and Pay"}
              </PayButton>
            </ButtonContainer>
            {error && (
              <p style={{ color: "red", textAlign: "center" }}>{error}</p>
            )}
            <ButtonContainer>
              <CancelButton onClick={handleCancel} type="button">
                Cancel
              </CancelButton>
            </ButtonContainer>
          </PaymentForm>
        </FormSection>
      </RowContainer>

      <Separator />

      <Footer />
    </Container>
  );
};

//SECTION - style
const Container = styled.div`
  max-width: 900px;
  margin: 100px auto;
  padding: 40px;
  background: white;
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  font-family: "Helvetica", "Arial", sans-serif;

  @media (max-width: 768px) {
    max-width: none;
    margin: 1rem 0 0 0;
    padding: 1rem;
  }
`;

const RowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const AmountSection = styled.div`
  text-align: center;
`;

const CurrencySymbol = styled.span`
  font-size: 1.5rem;
`;

const Amount = styled.span`
  font-size: 2rem;
  font-weight: bold;
  color: #005696;
`;

const FormSection = styled.div`
  min-width: 400px;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

const PaymentForm = styled.form``;

const FormGroup = styled.div`
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  label {
    font-weight: bold;
  }
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
  margin-top: 10px;
`;

// const Row = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 10px;

//   @media (max-width: 768px) {
//     flex-direction: column;
//   }
// `;

const CheckboxContainer = styled.label`
  margin: 10px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 0.8rem;
`;

// const Checkbox = styled.input`
//   cursor: pointer;
// `;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  /* border: 1px solid red; */
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: ${spin} 1s linear infinite;
  display: inline-block;
`;

const PayButton = styled.button`
  width: 100%;
  padding: 15px 40px;
  font-weight: 500;
  background-image: linear-gradient(45deg, #005696, #05825f);
  border: none;
  color: white;
  text-transform: uppercase;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  border-radius: 5px;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover {
    background-color: #d03759;
  }

  &:disabled {
    background: gray;
  }
`;

const CancelButton = styled(PayButton)`
  background: black;
  margin-top: 10px;
`;

const Separator = styled.hr`
  margin: 30px 0;
  border: none;
  border-top: 1px solid #ddd;
`;

export default Home;
